import { handleSessionOut } from "../Helpers/Helpers";
import { getToken } from "./tokenStore";
 
const NIMBLE_API = import.meta.env.VITE_BACKEND_API;
const NIMBLE_AUTH_API = import.meta.env.VITE_NIMBLE_AUTH_API;
const BUDGET_API = import.meta.env.VITE_BUDGET_API;
 
 
const validateToken = async () => {
 
    const token = getToken();
 
    let res = await fetch(`${NIMBLE_AUTH_API}/OpenApiauth/ValidateToken`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
    });
 
    let data = await res.json();
 
    if (data.statusCode !== 200) {
        await handleSessionOut();
        return false;
    }
 
    return true;
}
 
 
 
export const getHtmlRawData = async (body) => {
 
    const isValid = await validateToken();
    if (!isValid) {
        throw new Error("Session expired");
    }
 
    const res = await fetch(`${NIMBLE_API}/generate_html_report`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        }
    );
    if (!res.ok) {
        throw new Error(res || "GetHtmlData failed");
    };
 
    let data = await res.json();
    return data
};
 
 
export const exportFile = async (url, body) => {
 
    const isValid = await validateToken();
    if (!isValid) {
        throw new Error("Session expired");
    }
 
    const res = await fetch(`${NIMBLE_API}/${url}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    });
 
    if (!res.ok) {
        const err = await res.json();
        throw new Error(err?.message || "Export failed");
    }
 
    const blob = await res.blob();
 
    return {
        blob,
        headers: res.headers,
    };
};
 
 
// export const exportFile = async (url, body, responseType = "blob") => {
 
//     const isValid = await validateToken();
//     if (!isValid) {
//         throw new Error("Session expired");
//     }
 
//     const res = await fetch(`${NIMBLE_API}/${url}`, {
//         method: "POST",
//         headers: {
//             "Content-Type": "application/json",
//         },
//         body: JSON.stringify(body),
//     });
 
//     if (!res.ok) {
//         const err = await res.json();
//         throw new Error(err?.message || "Export failed");
//     }
 
//     if (responseType === "json") {
//         const data = await res.json();
//         return { data, headers: res.headers };
//     }
 
//     const blob = await res.blob();
//     return { blob, headers: res.headers };
// };
 
export const getJsonObject = async (redisKey) => {
 
    const isValid = await validateToken();
    if (!isValid) {
        throw new Error("Session expired");
    }
 
    const res = await fetch(`${BUDGET_API}/get-json-object?json_key=${redisKey}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error(res || "GetJsonObject failed");
    }
    let data = await res.json();
    return data
}
 
